import React, { useState, useEffect } from "react";

const Countdown = (prop) => {
  const secs = 70;
  const [count, setCount] = useState(secs);
  const [label, setLabel] = useState();
  const labels = prop.label;

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prevCount) => prevCount - 1);
    }, 1000);

    // Zatrzymaj odliczanie, gdy count osiągnie 0
    if (count === 0) {
      clearInterval(interval);
    }
    if (count === 70 || count % 6 === 0) {
      setLabel(labels[Math.floor(Math.random() * labels.length)]);
    }

    // Czyszczenie interwału po zakończeniu komponentu
    return () => clearInterval(interval);
  }, [count]);

  return (
    <span>
      {label} ({count})
    </span>
  );
};

export default Countdown;
